import React from 'react';
import { motion } from 'framer-motion';

export default function PerspectiveHero({ title, subtitle, children }) {
  return (
    <motion.section
      initial={{ opacity: 0, y: 24, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.55, ease: 'easeOut' }}
      className="relative"
    >
      {/* Perspective creates a "front exhibit" feeling */}
      <div style={{ perspective: '1400px' }}>
        <div className="relative rounded-[26px] border border-white/70 bg-white/55 p-5 md:p-7 shadow-[0_22px_56px_rgba(245,158,11,0.1)] backdrop-blur-xl">
          <div className="absolute inset-x-8 -bottom-6 h-10 rounded-[100%] bg-[radial-gradient(ellipse_at_center,_rgba(251,191,36,0.16)_0%,_rgba(251,191,36,0)_72%)] blur-md" />
          <div className="grid gap-4 md:grid-cols-[1.2fr_1fr] md:items-center">
            <div className="text-center md:text-left">
              <h1 className="font-serif text-xl font-semibold leading-snug tracking-tight text-[#2F251B] sm:text-2xl md:text-5xl md:font-black md:text-stone-900">
                {title}
              </h1>
              <p className="mx-auto mt-2 max-w-2xl text-xs leading-relaxed text-[#6B4E32] sm:text-sm md:mt-3 md:text-base md:text-stone-700">
                {subtitle}
              </p>
            </div>
            <div className="md:rounded-2xl md:border md:border-white/60 md:bg-white/65 md:p-4 md:shadow-inner">
              {children}
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
}
